import React, { Component } from 'react';
import { Bar } from 'react-chartjs-2';


class RepliesMentionsChart extends Component {

  // componentDidMount = () => {
  //   console.log(
  //     this.refs.replies_mentions_chart_ref.chart_instance
  //   );
  // };

  render() {

    let {
      replies_mentions_sums,
      replies_mentions_dates
    }
      = this.props;

    let sum_replies_mentions_sums = replies_mentions_sums.reduce((t, i) => t += i, 0);
    let count_replies_mentions_sums = replies_mentions_sums.size;

    let ary_replies_mentions_sums = replies_mentions_sums.toArray();
    let ary_replies_mentions_dates = replies_mentions_dates.toArray();

    return (
      <Bar
        ref='replies_mentions_chart_ref'
        // height={200}
        data={{
          datasets: [
            {
              label: 'retweets',
              data: ary_replies_mentions_sums,
              backgroundColor: 'black',
              hoverBackgroundColor: 'deepskyblue'
            }
          ],
          labels: ary_replies_mentions_dates
        }}
        options={{
          animation: {
            duration: 0
          },
          resize: true,
          maintainAspectRatio: false,
          legend: {
            display: false
          },
          title: {
            display: true,
            fontColor: 'deepskyblue',
            fontSize: 16,
            text: `${sum_replies_mentions_sums.toLocaleString()} replies +` +
            ` mentions / ${count_replies_mentions_sums} hours`
          },
          tooltips: {
            enabled: true,
            callbacks: {
              label: ((tooltipItem, data) => {
                return tooltipItem.yLabel.toLocaleString();
              })
            }
          },
          scales: {
            xAxes: {
              0: {
                // maxBarThickness: 20,
                gridLines: {
                  display: false,
                  drawBorder: false
                },
                ticks: {
                  autoSkip: true,
                  display: false,
                  fontSize: 11,
                  fontColor: 'blueviolet',
                  callback: ((value, index, values) => {
                    if (
                      (index === 0)
                      ||
                      (index === (count_replies_mentions_sums - 1)
                      )) {
                      return value;
                    }
                  })
                }
              }
            },
            yAxes: {
              0: {
                display: false,
              }
            }
          }
        }}
      />
    );
  }
}


export default RepliesMentionsChart;


// WEBPACK FOOTER //
// ./src/containers/engage/charts/RepliesMentionsChart.js